<div class="p-4">
  <!-- Título y Acción Principal -->
  <div class="flex justify-content-between align-items-center mb-4">
    <p-button *ngIf="!esDetalle"
      [label]="'GARANTIAPRODUCTOS.BTN_AGREGAR' | translate"
      [disabled]="!permisos.agrega"
      icon="pi pi-plus"
      (onClick)="toggleAddForm()"
      styleClass="p-button-outlined btn-premium">
    </p-button>
  </div>

  <!-- Bloque Agregar/Editar Garantía -->
  <div *ngIf="showAddForm" class="grid mb-4 bg-gray-50 border-round p-4 shadow-1 animate-fadein">
    <div class="col-12 mb-3">
      <h2 class="text-xl font-semibold m-0 text-primary">{{ 'GARANTIAPRODUCTOS.LBL_TITULO_AGREGAR' | translate }}</h2>
    </div>

    <form [formGroup]="registroForm" class="col-12 grid">
      <!-- Tipo garantía -->
      <div class="col-12 md:col-6 lg:col-3">
        <label class="block mb-2 font-medium">{{ 'GARANTIAPRODUCTOS.LBL_TIPO_GARANTIA' | translate }} *</label>
        <p-dropdown
          [options]="lisTiposGarantia"
          (onChange)="llenarLisClasesGarantia()"
          formControlName="tipoGarantia"
          [placeholder]="'GARANTIAPRODUCTOS.LBL_PLACEHOLDER_SELECCIONAR' | translate"
          emptyMessage="{{ 'GARANTIAPRODUCTOS.LBL_SINGARANTIA' | translate}}"
          styleClass="w-full">
        </p-dropdown>
        <small class="p-error" *ngIf="submitted && registroForm.get('tipoGarantia')?.invalid">
          {{ 'LBL_REQUERIDO' | translate }}
        </small>
      </div>

      <!-- Clase garantía -->
      <div class="col-12 md:col-6 lg:col-3">
        <label class="block mb-2 font-medium">{{ 'GARANTIAPRODUCTOS.LBL_CLASE_GARANTIA' | translate }} *</label>
        <p-dropdown
          [options]="lisClasesGarantia"
          formControlName="claseGarantia"
          [placeholder]="'GARANTIAPRODUCTOS.LBL_PLACEHOLDER_SELECCIONAR' | translate"
          (onChange)="llenarLisBienesDerechos()"
          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
          styleClass="w-full">
        </p-dropdown>
        <small class="p-error" *ngIf="submitted && registroForm.get('claseGarantia')?.invalid">
          {{ 'LBL_REQUERIDO' | translate }}
        </small>
      </div>

      <!-- Bien / derecho -->
      <div class="col-12 md:col-6 lg:col-3">
        <label class="block mb-2 font-medium">{{ 'GARANTIAPRODUCTOS.LBL_BIEN_DERECHO' | translate }} *</label>
        <p-dropdown
          [options]="lisBienesDerechos"
          formControlName="bienDerecho"
          [placeholder]="'GARANTIAPRODUCTOS.LBL_PLACEHOLDER_SELECCIONAR' | translate"
          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
          styleClass="w-full">
        </p-dropdown>
        <small class="p-error" *ngIf="submitted && registroForm.get('bienDerecho')?.invalid">
          {{ 'LBL_REQUERIDO' | translate }}
        </small>
      </div>

      <!-- Obligatorio desde -->
      <div class="col-12 md:col-6 lg:col-2">
        <label class="block mb-2 font-medium">{{ 'GARANTIAPRODUCTOS.LBL_OBLIGATORIO_DESDE' | translate }} *</label>
        <input
          numero-decimal-reactive
          [entero]="4"
          pInputText
          formControlName="obligatorioDesde"
          class="w-full"
          [placeholder]="'GARANTIAPRODUCTOS.LBL_PLACEHOLDER_INGRESAR' | translate" />
        <small class="p-error" *ngIf="submitted && registroForm.get('obligatorioDesde')?.invalid">
          {{ 'LBL_REQUERIDO' | translate }}
        </small>
      </div>

      <!-- Habilitado -->
      <div class="col-12 md:col-6 lg:col-1 flex align-items-center justify-content-center">
        <div class="flex flex-column align-items-center">
          <label class="mb-2 font-medium">{{ 'GARANTIAPRODUCTOS.LBL_HABILITADO' | translate }}</label>
          <p-inputSwitch formControlName="habilitado"></p-inputSwitch>
        </div>
      </div>

      <!-- Botones Acción Formulario -->
      <div class="col-12 flex justify-content-center gap-3 mt-4">
        <p-button
          [label]="'GARANTIAPRODUCTOS.BTN_CANCELAR' | translate"
          icon="fa fa-times"
          (onClick)="onCancelar()"
          styleClass="p-button-outlined p-button-secondary">
        </p-button>
        <p-button
          [label]="'GARANTIAPRODUCTOS.BTN_GUARDAR' | translate"
          icon="pi pi-check"
          (onClick)="onGuardar()"
          styleClass="p-button-success">
        </p-button>
      </div>
    </form>
  </div>

  <!-- Barra de Filtros -->
  <div class="grid mb-4 align-items-end">
    <div class="col-12 lg:col-8">
      <form [formGroup]="filtroForm" class="grid">
        <div class="col-12 md:col-8">
          <span class="p-input-icon-left w-full">
            <input
              type="text"
              pInputText
              formControlName="buscar"
              class="w-full"
              [placeholder]="'GARANTIAPRODUCTOS.LBL_BUSCAR' | translate" />
          </span>
        </div>
        <div class="col-12 md:col-4">
          <div class="flex align-items-center gap-2">
            <label class="white-space-nowrap font-medium">{{ 'GARANTIAPRODUCTOS.LBL_ESTADO' | translate }}</label>
            <p-dropdown
              [options]="lisEstados"
              formControlName="estado"
              [placeholder]="'LBL_SELECCIONE' | translate"
              styleClass="w-full">
            </p-dropdown>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12 lg:col-4 flex justify-content-end gap-2">
      <p-button
        [label]="'GARANTIAPRODUCTOS.BTN_FILTRAR' | translate"
        icon="pi pi-filter"
        (onClick)="onFiltrar()"
        styleClass="p-button-outlined">
      </p-button>
      <p-button
        [label]="'GARANTIAPRODUCTOS.BTN_LIMPIAR' | translate"
        icon="fa fa-eraser"
        (onClick)="onLimpiar()"
        styleClass="p-button-outlined p-button-secondary">
      </p-button>
    </div>
  </div>

  <!-- Tabla de Resultados -->
  <div class="shadow-1 border-round overflow-hidden">
    <p-table
      [value]="dataGarantias"
      [columns]="cols"
      [loading]="loading"
      [paginator]="true"
      [rows]="10"
      responsiveLayout="scroll"
      styleClass="p-datatable-sm table-premium">

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{ col.header | translate }}
            <p-sortIcon [field]="col.field" *ngIf="col.field !== 'acciones'"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">

              <!-- Badge de Estado -->
              <div *ngSwitchCase="'indicadorHabilitado'" class="text-center">
                <span [class]="'badge-' + (rowData[col.field] === true ? 'success' : 'danger')">
                  {{ (rowData[col.field] === true ? 'GARANTIAPRODUCTOS.LBL_ESTADO_HABILITADO' : 'GARANTIAPRODUCTOS.LBL_ESTADO_INHABILITADO') | translate }}
                </span>
              </div>

              <!-- Acciones por fila -->
              <div *ngSwitchCase="'acciones'" class="text-center">
                <p-button
                  [disabled]="!permisos.editar || esDetalle"
                  icon="fa fa-pencil"
                  (onClick)="onEditar(rowData)"
                  type="button"
                  styleClass="btn-action-premium"
                  [pTooltip]="'LBL_EDITAR' | translate">
                </p-button>
              </div>

              <!-- Celdas normales -->
              <span *ngSwitchDefault>{{ rowData[col.field] }}</span>
            </ng-container>
          </td>
        </tr>
      </ng-template>

      <!-- Estado Vacío -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="cols.length" class="text-center p-4">
            <div class="empty-state">
              <i class="pi pi-info-circle text-4xl mb-2 text-gray-400"></i>
              <p>{{ 'GARANTIAPRODUCTOS.MSG_SIN_RESULTADOS' | translate }}</p>
            </div>
          </td>
        </tr>
      </ng-template>

    </p-table>
  </div>
</div>

<p-toast></p-toast>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>
